import { jsx as _jsx } from "react/jsx-runtime";
import { useComposerState } from '#pplx/frontend/composer-sdk/internal/input-state/useComposerState.js';
import { EXTERNAL_VALUE_UPDATE_TAG } from '#pplx/frontend/composer-sdk/internal/updateTags.js';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useRef } from 'react';
const ControlledOnValueChangePlugin = function ControlledOnValueChangePlugin({ onValueChange }) {
    const [editor] = useLexicalComposerContext();
    const onValueChangeRef = useRef(onValueChange);
    onValueChangeRef.current = onValueChange;
    useEffect(() => {
        // Keep one subscription while allowing consumers to replace their callback.
        return editor.registerUpdateListener(({ dirtyElements, dirtyLeaves, editorState, tags }) => {
            // Selection-only updates do not change the controlled draft value.
            if (dirtyElements.size === 0 && dirtyLeaves.size === 0) {
                return;
            }
            // Consumer-driven replacements must not echo back into the controlled value flow.
            if (tags.has(EXTERNAL_VALUE_UPDATE_TAG)) {
                return;
            }
            onValueChangeRef.current(editorState.toJSON());
        });
    }, [editor]);
    return null;
};
export const OnValueChangePlugin = function OnValueChangePlugin() {
    const state = useComposerState();
    if (state.draftMode !== 'controlled') {
        return null;
    }
    return _jsx(ControlledOnValueChangePlugin, { onValueChange: state.onValueChange });
};
//# sourceMappingURL=OnValueChangePlugin.js.map